import React from "react";
// import Updatesm4 from "../specific/Updatesm4";
import { makeStyles } from "@mui/styles";
// import Updategps from "../specific/Updategps";
import AnyDesklogo from '../../assets/images/anydesklogo.png';
import AnyDeskPluginlogo from '../../assets/images/anydeskplugin.png';
import { Button, CardActions, Grid, Typography } from "@mui/material";
import AuthBuildHeaderUserObject from "../../usecases/AuthBuildHeaderUserObject";
import APIManager from "../../connection/APIManager";
import InfoCard from "../basic/InfoCard";
import { useEffect, useState } from "react";
import Sm4logo from '../../assets/images/SM4LOGO.png';
import Gpslogo from '../../assets/images/gpsLOGO.png';
import BackgroundImage from '../../assets/images/background.png';
import AuthCheckLogin from "../../usecases/AuthCheckLogin";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: '20px',
    marginRight: '20px',
    [theme.breakpoints.down('sm')]: {
      margin: '12px',
      marginRight: '12px',
    },
  },
  containerItem: {
    margin: '10px',
    width: '95%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      margin: '8px 0',
    },
  },
  img: {
    width: '200px',
    height: '190px',
    alignSelf: 'flex-start',
    padding: '10px',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      width: '120px',
      height: '120px',
      alignSelf: 'center',
      padding: '8px',
    },
  },
  title: {
    textAlign: 'center',
    fontSize: 'larger',
  },
  button: {
    width: '250px',
    height: '40px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      justifyContent: 'center',
    },
  },
  card: {
    height: 220,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '12px',
      padding: '8px 0',
      textAlign: 'center',
    },
  },
  backButton: {
    marginLeft: '30px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '12px',
    },
  },
}));


function Updates() {
  const classes = useStyles();
  const history = useHistory();
  const [sm4version, setSm4Version] = useState('');
  const [gpsversion, setGpsVersion] = useState('');
  const [error, setError] = useState(false);
  const [userData, setUserData] = useState(null);

  //Busca das versões do SM4 e GPS

  useEffect(() => {
      getSM4Version();
      getGPSVersion();
      getUserData();
  }, []);

  const getUserData = async () => {
      let userData = await AuthCheckLogin().catch(e =>{console.error(e); return null})
      
      setUserData(userData);
  }

  const getSM4Version = async () => {
    try {
      // const xpass = await AuthBuildHeaderUserObject();
      // if (!xpass) {
      //   return;
      // }

      const headers = {
        // ...xpass,
        auth_word: 'SAFRAMAXAUTH2090909',
        response_type: 'object',
      };


      const response = await APIManager.send('/serverinfo/sm4version', 'GET', headers);
      const json = await response.json();
      setSm4Version(json);
    } catch (error) {
      console.error('Erro ao buscar dados do servidor:', error);
    }
  };

  const getGPSVersion = async () => {
    try {
      // const xpass = await AuthBuildHeaderUserObject();
      // if (!xpass) {
      //   return;
      // }

      const headers = {
        // ...xpass,
        auth_word: 'SAFRAMAXAUTH2090909',
        response_type: 'object',
      }

      const response = await APIManager.send('/serverinfo/gpsversion', 'GET', headers);
      const json = await response.json();
      setGpsVersion(json);
    } catch (error) {
      console.error('Erro ao buscar dados do servidor:', error);
    }
  };

  //Download dos arquivos APKs

  const downloadSM4 = async () => {
    try {
      // const xpass = await AuthBuildHeaderUserObject();
      // if (!xpass) {
      //   setError(true);
      //   return;
      // }

      const headers = {
        // ...xpass,
        auth_word: 'SAFRAMAXAUTH2090909',
      };

      const response = await APIManager.send('/download/sm4/file', 'GET', headers);
      if (response.status === 200) {
        window.open(response.url, '_blank')
      } else {
        setError(true);
      }
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      setError(true);
    }
  };

  const downloadSM4Beta = async () => {
    try {
      const headers = {
        auth_word: 'SAFRAMAXAUTH2090909',
      };

      const response = await APIManager.send('/download/sm4/betaFile', 'GET', headers);
      if (response.status === 200) {
        window.open(response.url, '_blank')
      } else {
        setError(true);
      }
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      setError(true);
    }
  };

  const downloadSM4Firmware = async () => {
    try {
      // const xpass = await AuthBuildHeaderUserObject();
      // if (!xpass) {
      //   setError(true);
      //   return;
      // }

      const headers = {
        // ...xpass,
        auth_word: 'SAFRAMAXAUTH2090909',
      };

      const response = await APIManager.send('/download/sm4/firmware', 'GET', headers);
      if (response.status === 200) {
        window.open(response.url, '_blank')
      } else {
        setError(true);
      }
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      setError(true);
    }
  };

  const downloadGPS = async () => {
    try {
      // const xpass = await AuthBuildHeaderUserObject();
      // if (!xpass) {
      //   setError(true);
      //   return;
      // }

      const headers = {
        // ...xpass,
        auth_word: 'SAFRAMAXAUTH2090909',
      };

      const response = await APIManager.send('/download/gps/file', 'GET', headers);
      if (response.status === 200) {
        window.open(response.url, '_blank')
      } else {
        setError(true);
      }
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      setError(true);
    }
  };

  const downloadGPSFirmware = async () => {
    try {
      // const xpass = await AuthBuildHeaderUserObject();
      // if (!xpass) {
      //   setError(true);
      //   return;
      // }

      const headers = {
        // ...xpass,
        auth_word: 'SAFRAMAXAUTH2090909',
      };

      const response = await APIManager.send('/download/gps/firmware', 'GET', headers);
      if (response.status === 200) {
        window.open(response.url, '_blank')
      } else {
        setError(true);
      }
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      setError(true);
    }
  };

  const downloadBackground = () => {
    const fileLink = document.createElement('a');
    fileLink.href = BackgroundImage;
    fileLink.setAttribute('download', 'background.png');
    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);
  };

  const downloadRemoteApp = async () => { 
    try {
      // const xpass = await AuthBuildHeaderUserObject();
      // if (!xpass) {
      //   return
        
      // }

       const headers = {
        //  ...xpass
      }

      const response = await APIManager.send('/download/remoteapp/file' , 'GET', headers)
      if (response.status === 200) {
        window.open(response.url, '_blank')
      } else {
        setError(true);
      }
    } catch (error) {
      console.error('Erro ao baixar o arquivo AnyDesk ', error)
    }
  }

  const downloadPlugin = async () => { 
    try {
      // const xpass = await AuthBuildHeaderUserObject();
      // if (!xpass) {
      //   return
      // }

       const headers = {
        //  ...xpass
      }

      const response = await APIManager.send('/download/pluginremoteapp/file' , 'GET', headers)
      if (response.status === 200) {
        window.open(response.url, '_blank')
      } else {
        setError(true);
      }
    } catch (error) {
      console.error('Erro ao baixar o arquivo AnyDesk ', error)
    }
  }

  
  return (
    <div style={{ width: '100%', }}>
      {
        userData && (
          <Button variant="contained" color="primary" onClick={() => {history.push('/dashboard')}} className={classes.backButton}>
            Voltar
          </Button>
        )
      }
      <Grid container className={classes.container}>
        <Grid item className={classes.containerItem}>
          <InfoCard className={classes.card}>
            <div className={classes.cardContent}>
                <img src={Sm4logo} alt="Sm4" className={classes.img} /> 
              <Typography variant="h6">Aplicativo do SM4: {sm4version.sm4version}</Typography>
              <div className={classes.button}>
                <Button variant="contained" color="success" fullWidth onClick={downloadSM4}>
                  DOWNLOAD
                </Button>
              </div>
            </div>
          </InfoCard>
        </Grid>

        <Grid item className={classes.containerItem}>
          <InfoCard className={classes.card}>
            <div className={classes.cardContent}>
                <img src={Sm4logo} alt="Sm4 Beta" className={classes.img} />
              <Typography variant="h6">Aplicativo do SM4 Beta</Typography>
              <div className={classes.button}>
                <Button variant="contained" color="success" fullWidth onClick={downloadSM4Beta}>
                  DOWNLOAD
                </Button>
              </div>
            </div>
          </InfoCard>
        </Grid>

        <Grid item className={classes.containerItem}>
          <InfoCard className={classes.card}>
            <div className={classes.cardContent}>
                <img src={Sm4logo} alt="Sm4" className={classes.img} /> 
              <Typography variant="h6">Firmware do SM4: {sm4version.sm4firmware}</Typography>
              <div className={classes.button}>
                <Button variant="contained" color="success" fullWidth onClick={downloadSM4Firmware}>
                  DOWNLOAD
                </Button>
              </div>
            </div>
          </InfoCard>
        </Grid>

        <Grid item className={classes.containerItem}>
          <InfoCard className={classes.card}>
            <div className={classes.cardContent}>
              <img src={BackgroundImage} alt="Imagem Saframax para fundo de tela" className={classes.img} />
              <Typography variant="h6" className={classes.title}>Imagem Saframax para fundo de tela</Typography>
              <div className={classes.button}>
                <Button variant="contained" color="success" fullWidth onClick={downloadBackground}>
                  DOWNLOAD
                </Button>
              </div>
            </div>
          </InfoCard>
        </Grid>

        <Grid item className={classes.containerItem}>
          <InfoCard className={classes.card}>
            <div className={classes.cardContent}>
              <img src={Gpslogo} alt="GPS" className={classes.img} /> 
              <Typography variant="h6" className={classes.title}>Aplicativo do GPS: {gpsversion.gpsversion}</Typography>
              <div className={classes.button}>
                <Button variant="contained" color="success" fullWidth onClick={downloadGPS}>
                  DOWNLOAD
                </Button>
              </div>
            </div>
          </InfoCard>
        </Grid>

        <Grid item className={classes.containerItem}>
          <InfoCard className={classes.card}>
            <div className={classes.cardContent}>
              <img src={Gpslogo} alt="GPS" className={classes.img} /> 
              <Typography variant="h6" className={classes.title}>Firmware do GPS: {gpsversion.gpsfirmware}</Typography>
              <div className={classes.button}>
                <Button variant="contained" color="success" fullWidth onClick={downloadGPSFirmware}>
                  DOWNLOAD
                </Button>
              </div>
            </div>
          </InfoCard>
        </Grid>

        <Grid item className={classes.containerItem}>
          <InfoCard className={classes.card}>
            <div className={classes.cardContent}>
              <img src={AnyDesklogo} alt="AnyDesk" className={classes.img} />
              <Typography variant="h6" className={classes.title}>
                  Arquivo instalador Anydesk APK
              </Typography>
              <div className={classes.button}>
                <Button variant="contained" color="success" fullWidth onClick={downloadRemoteApp}>
                  DOWNLOAD
                </Button>
              </div>
            </div>
          </InfoCard>
        </Grid>

        <Grid item className={classes.containerItem}>
          <InfoCard className={classes.card}>
            <div className={classes.cardContent}>
              <img src={AnyDeskPluginlogo} alt="Plugin" className={classes.img} />
              <Typography variant="h6" className={classes.title}>Arquivo instalador Anydesk Plugin Samsung apk</Typography>
              <div className={classes.button}>
                <Button variant="contained" color="success" fullWidth onClick={downloadPlugin}>
                  DOWNLOAD
                </Button>
              </div>
            </div>
          </InfoCard>
        </Grid>

      </Grid>
    </div>
  );
}


export default Updates;